<template lang="html">
	<div class="loader-container" v-if="loader">
		<div class="loader-image">
			<img class="color-filter" src="~@/common/assets/img/loader.svg" alt="">
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'loader',
	mounted () {
		this.$store.commit('LOADER_OUT')
	},
	computed: {
		...mapGetters({
			loader: 'isLoader'
		})
	}
}
</script>

<style lang="scss" scoped>
	.loader-container {
		z-index: 50000;
		background-color: rgba(white, 0.4);
		width: 100vw;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 0;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.color-filter {
		fill: var(--secondary) !important;
	}
</style>



// WEBPACK FOOTER //
// loader.vue?1f284eda